import type { Address } from 'viem';
import { formatUnits } from 'viem';
import { arbitrum, base, mainnet, optimism, polygon, sepolia } from 'viem/chains';

/**
 * Format an Ethereum address to a short form (0x1234...5678)
 */
export const formatAddress = (address?: Address | string): string => {
  if (!address) return '';
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
};

/**
 * Format balance to display (4 decimal places)
 */
export const formatBalance = (balance: string = ''): string => {
  return parseFloat(balance || '0').toFixed(4);
};

/**
 * Get human-readable network name from chain ID
 */
export const getNetworkName = (chainId: number): string => {
  const networkMap: Record<number, string> = {
    [mainnet.id]: mainnet.name,
    [polygon.id]: polygon.name,
    [optimism.id]: optimism.name,
    [arbitrum.id]: arbitrum.name,
    [base.id]: base.name,
    [sepolia.id]: sepolia.name,
  };
  return networkMap[chainId] || `Chain ID: ${chainId}`;
};

/**
 * Format wei to ether with custom decimals
 */
export const formatEther = (wei: bigint, decimals: number = 4): string => {
  const ether = formatUnits(wei, 18);
  return parseFloat(ether).toFixed(decimals);
};
